package ru.it_mozaika.sender.js.application.frames.quarantine

import io.ktor.client.call.*
import js.core.ReadonlyRecord
import js.core.jso
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.ColumnsFilter
import ru.it_mozaika.sender.common.models.Quarantine
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.quarantine.deleteFromQuarantineDialog
import ru.it_mozaika.sender.js.application.context.BackdropContext
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import web.cssom.*
import mui.icons.material.DeleteForeverSharp
import mui.material.styles.Theme
import mui.material.styles.useTheme
import ru.it_mozaika.components.commonTableSkeletonFrame

val QuarantineFrame = VFC {
    val (size, setSize) = useState(0)
    val (selectedProperty, setSelectedProperty) = useState("")
    val (rowsPerPage, setRowsPerPage) = useState(10)
    val (page, setPage) = useState(0)
    val (quarantine, setQuarantine) = useState(listOf<Quarantine>())
    val (checkedProperties, setCheckedProperties) = useState(listOf<String>())
    val (showFilter, setShowFilter) = useState(false)
    var (columnVisibility, setColumnVisibility) = useState<ReadonlyRecord<String, Boolean>>(jso {})
    val (columnOrder, setColumnOrder) = useState<ColumnOrderState>(jso {})
    val (propertiesDict, setPropertiesDict) = useState<ColumnsFilter>()
    val (searchQuery, setSearchQuery) = useState("")
    val (propertiesFilter, setPropertiesFilter) = useState<List<ColumnsFilter>>(listOf())
    val tableColumns = listOf("Email", "Тип карантина", "Дата добавления")
    val (selectedQuarantine, setSelectedQuarantine) = useState<List<Quarantine>>(listOf())
    val backdrop = useContext(BackdropContext)
    val (showDialog, setShowDialog) = useState(false)
    val theme = useTheme<Theme>()
    val table = useReactTable<Quarantine>(
        options = jso {
            columns = useMemo(tableColumns) {
                tableColumns.map { column ->
                    jso<ColumnDef<Quarantine, Any?>> {
                        accessorFn = { q, _ ->
                            when (column) {
                                "Email" -> q.email
                                "Тип карантина" -> q.quarantineType
                                "Дата добавления" -> q.date.toLocalDateTime(TimeZone.UTC).date
                                else -> ""
                            }
                        }
                        cell = ColumnDefTemplate { context ->
                            val value = context.getValue().toString()
                            Box.create {
                                +value
                            }
                        }
                        id = column
                        header = StringOrTemplateHeader(column)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(quarantine) { quarantine.toTypedArray() }
            this.state = jso {
                this.columnVisibility = columnVisibility
                this.columnOrder = columnOrder
            }
            this.onColumnVisibilityChange = {
                columnVisibility = it.unsafeCast<ReadonlyRecord<String, Boolean>>()
                setColumnVisibility(it.unsafeCast<ReadonlyRecord<String, Boolean>>())
            }
            this.onColumnOrderChange = {
                setColumnOrder(it.unsafeCast<Array<String>>())
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )

    fun getQuarantine() {
        backdrop.show()
        Http.get(
            "/quarantine",
            mapOf(
                "page" to (page + 1).toString(),
                "rows" to rowsPerPage.toString(),
                "search" to searchQuery
            )
        ) { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            val list = response.body<List<Quarantine>>()
            setQuarantine(list)
            backdrop.hide()
        }
        backdrop.show()
        Http.get("/quarantine/size", mapOf("search" to searchQuery)) { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            setSize(response.body<Int>())
            backdrop.hide()
        }
    }
    useEffect(rowsPerPage, page, searchQuery) { getQuarantine() }
//    tableFilter {
//        this.showFilter = showFilter
////        this.propertiesDict = propertiesDict
////        this.selectedProperty = selectedProperty
//        this.onClose = {
//            setShowFilter(false)
//            setSelectedProperty("")
//        }
//        this.handleOnSetCheckedValues = { selectedProperty, list ->
//            setCheckedProperties(list)
//            setPropertiesFilter {
//                if (list.isNotEmpty()) {
//                    if (propertiesFilter.find { property ->
//                            property.columnName == selectedProperty
//                        } == null) {
//                        val newValue = it.plus(ColumnsFilter(selectedProperty, list))
//                        newValue
//                    } else {
//                        val newValue = it.map { item ->
//                            if (item.columnName == selectedProperty) ColumnsFilter(
//                                selectedProperty,
//                                list
//                            ) else item
//                        }
//                        newValue
//                    }
//                } else {
//                    listOf()
//                }
//            }
//        }
//        this.checkedProperties = checkedProperties
//    }
    deleteFromQuarantineDialog {
        this.selected = selectedQuarantine
        this.onClose = {
            setShowDialog(false)
            getQuarantine()
        }
        this.isOpen = showDialog
    }
    MainCard {
        title = "Карантин"
        Toolbar {
            sx {
                display = Display.flex
                flexWrap = FlexWrap.wrap
                paddingTop = 7.px
            }
            Stack {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                searchField {
                    this.onSearchQueryChange = {
                        setSearchQuery(it)
                    }
                }
            }
        }
        Divider {
            this.orientation = Orientation.horizontal
        }
        commonTableSkeletonFrame {
            this.currentSelected = selectedQuarantine.map { it.email }
            this.toolbarActions = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                if (checkedProperties.isNotEmpty()) {
                    filterOffButton {
                        this.propertiesFilter = checkedProperties
                        this.handleOnFilterOffClick = {
                            setCheckedProperties(listOf())
                            setPropertiesFilter(listOf())
                            setSearchQuery("")
                        }
                    }
                }
                if (selectedQuarantine.isNotEmpty()) {
                    AvatarButton {
                        this.tooltipTitle = "Удалить из карантина"
                        onClick = {
                            setShowDialog(true)
                        }
                        palettecolor = theme.palette.error
                        DeleteForeverSharp()
                    }
                }
            }
            this.label = "quarantine"
            this.propertiesFilter = propertiesFilter
            this.columnId = "Email"
            this.table = table
            this.onPropertySelect = { property ->
                setSelectedProperty(property)
                if (showFilter) setShowFilter(false) else setShowFilter(true)
            }
            this.onSelectionChanged = { newSelected ->
                val newList = newSelected.mapNotNull { email ->
                    val q = quarantine.find {
                        it.email == email
                    }
                    q
                }
                setSelectedQuarantine(newList)
            }
        }
        TablePagination {
            this.page = page
            this.count = size
            this.onPageChange = { _, newPage ->
                setPage(newPage.toInt())
            }
            this.onRowsPerPageChange = { event ->
                setRowsPerPage(event.target.asDynamic().value as Int)
                setPage(0)
            }
            this.rowsPerPage = rowsPerPage
        }
    }
}